import React from 'react';
import { graphql } from 'gatsby';
import DownloadAppTemplate from 'templates/download-app';
import { useTranslation } from 'react-i18next';

const DownloadAppPAge = props => {
  const [t] = useTranslation();
  return (
    <DownloadAppTemplate
      {...props}
      seoTitle={t('page--download.seoTitle')}
      seoDescription={t('page--download.seoDescription')}
    />
  )
};
export default DownloadAppPAge;

// export const query = graphql`
//   query DownloadAppPAge {
//     strapiPages(slug: { eq: "/ladda-ner-appen" }) {
//       id
//       title
//       subtitle
//       headerImage {
//         childImageSharp {
//           fluid(maxHeight: 1024, quality: 100) {
//             ...GatsbyImageSharpFluid_withWebp
//           }
//         }
//       }
//       content
//       seoTitle
//       seoDescription
//     }
//   }
// `;
